import * as React from 'react'
import { PlusOutlined, DownOutlined, DeleteOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useState } from 'react'
import AddTax from '../../TaxRates/modals/AddTax'
import { Tax } from '../../TaxRates'
import { useTaxes } from '../../TaxRates/queries'
import ContributorButton from '../../ContributorButton'
import styled from 'styled-components'
import Amount from '../../Amount'
import TaxRow from '../../TaxRates/TaxRow'

type Props = {
  value?: Tax
  onChange?: (_?: Tax) => void
  total?: number
  unit?: string
}

const TaxName = styled.div`
  padding-left: 8px;
  flex: 111;
`

const TaxAmount = styled.div`
  padding-left: 8px;
  flex: 108;
`

const TaxAction = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 104;
`

const SelectTax = ({ value, onChange, total, unit }: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const taxesQuery = useTaxes({ itemsPerPage: 50, page: 0 })

  return (
    <div>
      <AddTax
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      />
      <Dropdown
        disabled={!!value}
        overlay={
          <Menu
            onClick={({ key }) => {
              onChange?.(taxesQuery.data?.data.find(d => `${d.id}` === key))
            }}
          >
            <Menu.Item key="action">
              <ContributorButton
                onClick={() => setIsModalVisible(true)}
                icon={<PlusOutlined />}
              >
                <FormattedMessage id="Tax_Add_Tax" />
              </ContributorButton>
            </Menu.Item>
            {taxesQuery.data?.data.map(d => (
              <Menu.Item key={d.id}>{d.name}</Menu.Item>
            ))}
          </Menu>
        }
      >
        <Button type="link" loading={taxesQuery.isLoading} disabled={!!value}>
          <FormattedMessage id="addTax" />
          <DownOutlined />
        </Button>
      </Dropdown>
      {!!value && (
        <TaxRow
          {...value}
          total={total}
          unit={unit}
          actions={
            <Button
              type="text"
              icon={<DeleteOutlined />}
              onClick={() => onChange?.(undefined)}
            />
          }
        />
      )}
    </div>
  )
}
export default SelectTax
